import { imageFieldsFrag } from '@/service/fragments/imageFieldsFrag'
import { gql } from '@/service/gql'
import type { ResultOf } from 'gql.tada'
import { playableEntityFrag } from '@/service/fragments/playableEntityFrag'

// language=GraphQL
export const podcastShowFieldsFrag = gql(
    `
        fragment podcastShowFields on PodcastShow @_unmask {
            ...playableEntity
            id
            title
            url
            images {
                ...imageFields
            }
            followsContext @include(if: $isAuthenticated) {
                isFollowed
            }
        }
    `,
    [imageFieldsFrag, playableEntityFrag]
)

export type PodcastShowFields = ResultOf<typeof podcastShowFieldsFrag>
